import { CartUpdateReceiveEvent } from '@front-office/app-common-cart/build/store/cart';
import {
  clearCart,
  removeCartItemsGroup
} from '@front-office/app-common-cart';
import { ReducerCreators, current } from '@reduxjs/toolkit';
import { ProductEntity, ProductId } from '../types';
import {
  ProductsStoreState,
  ProductsStoreSucceeded,
  ProductWithAnalytics,
  ProductCommonCartProps
} from './types';
import {
  OnAfterProductCancelDeletion,
  OnAfterProductDecrease,
  OnAfterProductIncrease,
  OnAfterProductInputQuantity,
  OnAfterProductMarkForDeletion
} from '../../services/dispatchers';

const productsStoreSucceededReducers = (
  create: ReducerCreators<ProductsStoreState>
) => ({
  increaseQuantity: create.reducer<ProductCommonCartProps>(
    (state: ProductsStoreSucceeded, { payload }) => {
      const { id, newQuantity } = payload;
      const product = current(state).entities[id];

      OnAfterProductIncrease.dispatch({
        ...product,
        ...{ quantity: newQuantity }
      });
    }
  ),
  decreaseQuantity: create.reducer<ProductCommonCartProps>(
    (state: ProductsStoreSucceeded, { payload }) => {
      const { id, newQuantity } = payload;
      const product = state.entities[id];

      OnAfterProductDecrease.dispatch({
        ...product,
        ...{ quantity: newQuantity }
      });
    }
  ),
  setQuantity: create.reducer<ProductCommonCartProps>(
    (state: ProductsStoreSucceeded, { payload }) => {
      const { id, newQuantity } = payload;
      const product = current(state).entities[id];

      OnAfterProductInputQuantity.dispatch({
        ...product,
        ...{ quantity: newQuantity }
      });
    }
  ),
  markForDeletion: create.reducer<ProductId[]>(
    (state: ProductsStoreSucceeded, { payload }) => {
      payload.forEach((productId) => {
        state.entities[productId].forDeletion = true;
        OnAfterProductMarkForDeletion.dispatch(
          state.entities[productId]
        );
      });
    }
  ),
  markAsDeleted: create.reducer<ProductId>(
    (state: ProductsStoreSucceeded, { payload }) => {
      state.entities[payload].isDeleted = true;
    }
  ),
  cancelDeletion: create.reducer<ProductId>(
    (state: ProductsStoreSucceeded, { payload }) => {
      state.entities[payload].forDeletion = false;

      OnAfterProductCancelDeletion.dispatch(
        state.entities[payload]
      );
    }
  ),
  deleteProducts: create.asyncThunk<
    CartUpdateReceiveEvent,
    ProductId[]
  >(
    async (payload) => {
      return await removeCartItemsGroup(payload);
    },
    {
      pending: (state) => {
        state.loading = 'pending';
      },
      rejected: (state, { error }) => {
        state.loading = 'failed';
        state.error = error;
      }
    }
  ),
  deleteAllProducts: create.asyncThunk<void>(
    async () => {
      await clearCart();
    },
    {
      pending: (state) => {
        state.loading = 'pending';
      },
      rejected: (state, { error }) => {
        state.loading = 'failed';
        state.error = error;
      },
      fulfilled: (state) => {
        state.loading = 'succeeded';
      }
    }
  )
});

export default (
  create: ReducerCreators<ProductsStoreState>
) => ({
  updateProducts: create.reducer<
    ProductEntity<ProductWithAnalytics> | object
  >((state, { payload }) => {
    state.entities = payload;
    state.ids = Object.keys(payload);
    state.loading = 'succeeded';
  }),
  ...productsStoreSucceededReducers(create)
});
